"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FunctionExpression = exports.Function = exports.Return = void 0;
const callable_1 = require("./callable");
const environment_1 = require("./environment");
class Return extends Error {
    constructor(value) {
        super();
        this.value = value;
    }
}
exports.Return = Return;
class Function extends callable_1.Callable {
    constructor(declaration, closure, isInitializer, isGetter) {
        super();
        this.declaration = declaration;
        this.closure = closure;
        this.isInitializer = isInitializer;
        this.isGetter = isGetter;
    }
    arity() {
        return this.declaration.params.length;
    }
    call(interpreter, args) {
        var _a;
        const env = new environment_1.Environment(this.closure);
        (_a = this.declaration.params) === null || _a === void 0 ? void 0 : _a.forEach((param, i) => {
            env.define(param.lexeme, args[i]);
        });
        try {
            interpreter.executeBlock(this.declaration.body, env);
        }
        catch (error) {
            if (error instanceof Return) {
                if (this.isInitializer) {
                    return this.closure.getAt(0, 'this');
                }
                return error.value;
            }
            throw error;
        }
        if (this.isInitializer) {
            return this.closure.getAt(0, 'this');
        }
    }
    bind(instance) {
        const env = new environment_1.Environment(this.closure);
        env.define('this', instance);
        return new Function(this.declaration, env, this.isInitializer, this.isGetter);
    }
}
exports.Function = Function;
class FunctionExpression extends callable_1.Callable {
    constructor(declaration, closure) {
        super();
        this.declaration = declaration;
        this.closure = closure;
    }
    arity() {
        return this.declaration.params.length;
    }
    call(interpreter, args) {
        var _a;
        const env = new environment_1.Environment(this.closure);
        (_a = this.declaration.params) === null || _a === void 0 ? void 0 : _a.forEach((param, i) => {
            env.define(param.lexeme, args[i]);
        });
        try {
            interpreter.executeBlock(this.declaration.body, env);
        }
        catch (error) {
            if (error instanceof Return) {
                return error.value;
            }
            throw error;
        }
    }
}
exports.FunctionExpression = FunctionExpression;
